<template>
  <SelectPortalCompany :portal="portal"/>
</template>

<script>
import SelectPortalCompany from "../../../../../../../../components/Administration/PortalCompanies/Panels/Select.vue";

export default {
  components: {SelectPortalCompany},

  props: {
    portal: {
      required: true,
      type: Object
    }
  }
}
</script>
